import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Callforpapers from "./pages/Callforpapers";
import Loja from "./pages/Loja";
import ScrollToHash from "./components/ScrollToHash";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/congreso-ingenieria-estructural">
    <ScrollToHash></ScrollToHash>
      <Header></Header>
      <Routes>
        <Route index element={<Home />} />

        <Route path="call-for-papers" element={<Callforpapers />} />
        <Route path="loja" element={<Loja />} />
      </Routes>

      <Footer></Footer>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
